module.exports = __webpack_public_path__ + "static/img/bg-en.d89f4bb1.png";